<mat-card>
    <mat-card-content class="newOrder">
        <div class="titleHead">
            <div class="titleLeft ">
                <title-back [addTitle]="true" [Title]="'Verify KYC'" (back)="closeDetails()"> </title-back>
                <div class="tableFilter">
                    <logzy-reports-table [downloadButtons]="true"
                        [pageName]="'verify_customer_kyc'"></logzy-reports-table>

                    <app-mat-auto-search [isEditable]="true" [name]="'kyc_status_list'"
                        [placeholder]="'Filter by status'" [ngModel]="statusFilter"
                        (ngModelChange)="filterByApprovalStatus($event)" [options]="statusList" [setSearchValue]="false"
                        [searchable]="false" [idField]="null" [displayField]="'name_kyc'" fxFlex="14em">
                    </app-mat-auto-search>

                    <mat-form-field appearance="outline" fxFlex="14em">
                        <input matInput [ngModel]="searchTerm" (ngModelChange)="applyFilter($event)"
                            placeholder="Search">
                        <i class="flaticon-search" matSuffix></i>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <logzy-table-loader *ngIf="loading"></logzy-table-loader>
        <div class="setTable" *ngIf="!loading">
            <ng-container *ngIf="customerList?.data.length">
                <mat-table [dataSource]="customerList" matSort (matSortChange)="announceSortChange($event)">

                    <ng-container matColumnDef="legal_name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Company Name </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span class="companyName" (click)="viewCustomerMaster(element)">{{element.legal_name ??
                                '-'}}</span>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="address">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Address </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <span class="address" (click)="viewCustomerMaster(element)">{{element.address ??
                                '-'}}</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="country">
                        <mat-header-cell *matHeaderCellDef mat-sort-header> Country </mat-header-cell>
                        <mat-cell *matCellDef="let element"  class="fs-13">
                            {{element.country?.name_display ?? '-'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="kyc_status">
                        <mat-header-cell *matHeaderCellDef> KYC Status </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="fs-13">
                            <mat-chip (click)="viewCustomerMaster(element)"
                                [style.background-color]=" element?.kyc_status?.color_code" style="color:white">
                                <!-- [class.reject]="element.kyc_status.dev_name=='rejected'"
                                [class.approved]="element.kyc_status.dev_name=='approved' || element.kyc_status.dev_name=='auto_approved'" -->
                                {{element.kyc_status.name_kyc}}
                            </mat-chip>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="last_action_on">
                        <mat-header-cell *matHeaderCellDef> Active since </mat-header-cell>
                        <mat-cell *matCellDef="let element" class="fs-13">
                            {{element.created_at ?? '-' | date:'dd MMM, yyyy'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
                        <mat-cell *matCellDef="let element">
                            <div class="actions">
                                <i class="flaticon-view" (click)="viewCustomerMaster(element)"></i>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row class="header-row" *matHeaderRowDef="displayColumns"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayColumns;"
                        [class.blur]="refreshCustomerList"></mat-row>
                </mat-table>

                <div class="loadingData" [class.d-none]="!refreshCustomerList">
                    <logzy-gear-loader></logzy-gear-loader>
                </div>

                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page of users" [pageSize]="10"
                    [length]="customerPageLength" (page)="pageChanged($event)" #paginator></mat-paginator>
            </ng-container>
            <ng-container *ngIf="!customerList?.data.length">
                <logzy-billu [part1]="part1" [part2]="part2" [part3]="part3" font="14px"></logzy-billu>
            </ng-container>
        </div>
    </mat-card-content>
</mat-card>